import { ObjectBuilder, MeshUtils } from "@dreamcam/babylon-tools";
import { Env } from "../../settings/Env";
import { MeshName } from "../MeshName";
import { DcRenderingGroup } from "../DcRenderingGroup";
import { TransformNode } from "@babylonjs/core/Meshes/transformNode.js";
import { Vector3 } from "@babylonjs/core/Maths/math.vector.js";
import { Container } from "@babylonjs/gui/2D/controls/container.js";
import { Control } from "@babylonjs/gui/2D/controls/control.js";
import { Rectangle } from "@babylonjs/gui/2D/controls/rectangle.js";
export class Fps3D {
    constructor(scene, guiRootNode) {
        const transformNode = new TransformNode("fpsNode");
        // transformNode.position = scene.activeCamera?.position || Vector3.Zero();
        transformNode.rotate(Vector3.Left(), Math.PI * Env.fps.angle / 180);
        transformNode.setParent(guiRootNode);
        this._mesh2D = MeshUtils.createPlaneMesh(MeshName.fpsMesh, Env.fps.width, Env.fps.height, scene, transformNode, DcRenderingGroup.dialogs);
        this._mesh2D.mesh.isPickable = false;
        this._mesh2D.mesh.position = Vector3.Forward().scale(Env.fps.distance);
        const container = new Container("fpsContainer");
        container.widthInPixels = this._mesh2D.m2px(Env.fps.width);
        container.heightInPixels = this._mesh2D.m2px(Env.fps.height);
        container.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_CENTER;
        container.verticalAlignment = Control.VERTICAL_ALIGNMENT_CENTER;
        this._mesh2D.texture.addControl(container);
        const backgroundPanel = new Rectangle("fpsPanelBackground");
        backgroundPanel.widthInPixels = this._mesh2D.m2px(Env.fps.width);
        backgroundPanel.heightInPixels = this._mesh2D.m2px(Env.fps.height);
        backgroundPanel.paddingTopInPixels = 1; // Babylon-js bug workaround.
        backgroundPanel.cornerRadius = this._mesh2D.m2px(Env.fps.cornerRadius);
        backgroundPanel.background = Env.fps.backgroundColor;
        backgroundPanel.thickness = 0;
        container.addControl(backgroundPanel);
        const textBlock = ObjectBuilder.createTextBlock3D(this._mesh2D, "fpsText", "000", {
            width: Env.fps.width,
            height: Env.fps.height,
            horizontalAlignment: Control.HORIZONTAL_ALIGNMENT_CENTER,
            verticalAlignment: Control.VERTICAL_ALIGNMENT_CENTER,
            textHorizontalAlignment: Control.HORIZONTAL_ALIGNMENT_CENTER,
            textVerticalAlignment: Control.VERTICAL_ALIGNMENT_CENTER,
            color: Env.fps.text.color,
            fontWeight: Env.fps.text.fontWeight,
            fontSize: Env.fps.text.fontSize,
        });
        container.addControl(textBlock);
        scene.beforeRender = () => textBlock.text = Math.round(scene.getEngine().getFps()).toString();
    }
    dispose() {
        this._mesh2D.dispose();
    }
}
